import React from "react";
import { Col, Row } from "react-bootstrap";
import "./formimage.scss";
const FormImage = ({
  children,
  image,
  title,
  subtitle,
  imageOverlay,
  imageClassName,
  imageInMobile = true,
  bgClass,
}) => {
  return (
    <div className="d-flex justify-content-center bg-unauth-body">
      <Row className="w-100 pb-5 pb-md-1 pb-lg-1">
        <Col xs={12} sm={12} md={6}>
          <Row className="justify-content-center h-100 align-items-center">
            <Col sm={3}></Col>
            <Col sm={6}>
              <div className="d-flex flex-column justify-content-between align-items-center">
                {children}
                <div className="footer font-secondary text-light-grey position-static">
                  <div>©taabl inc. 2021</div>
                </div>
              </div>
            </Col>
            <Col sm={3}></Col>
          </Row>
        </Col>
        <Col
          xs={12}
          sm={12}
          md={6}
          className={`${
            imageInMobile
              ? "d-md-block max-vh-100 mt-5 mt-lg-0"
              : "d-none d-md-block d-lg-block max-vh-100 mt-5 mt-lg-0"
          }`}
        >
          <div
            className={`d-flex flex-column justify-content-center align-items-center h-100 ${bgClass}`}
          >
            <div className="d-flex position-relative">
              <img src={image} className={"img-fluid"} />
              {imageOverlay && (
                <div className="image-overlay">{imageOverlay}</div>
              )}
            </div>
            <div className="">
              <h2 className="mt-5 text-center pb-3">{title}</h2>
              <div className="text-center w-100 display-7 font-weight-normal d-flex justify-content-center">
                <div className="subtitle">{subtitle}</div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default FormImage;
